"use client";

import { HeadlineSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import GeneratedHeadlineSection from "../Components/GeneratedHeadlineSection";

const Headline: FC<HeadlineSectionProps> = (props) => {
  return <GeneratedHeadlineSection {...props} />;
};

export default Headline;
